const teamLevel = {
    path: '/teamManage/teamLevel',
    component: resolve => require(['@/views/team/teamLevel'], resolve),
    name: 'teamLevel',
    meta: {title: '队伍等级'}
};
const team = {
    path: '/teamManage/team',
    component: resolve => require(['@/views/team/team'], resolve),
    name: 'team',
    meta: {title: '队伍管理'}
};

export default [teamLevel,team]


// WEBPACK FOOTER //
// ./src/router/modules/teamMange.js